<template>
    <v-container fluid grid-list-lg :data-watch-loader="watchLoader">
    <v-layout v-if="loading && $route.params.machineId" justify-center align-center fill-height>
        <loader></loader>
    </v-layout>
    <v-layout v-else row justify-start wrap>
        <v-flex xs12 sm7>
            <autocomplete-selector
              :items="$store.state.machines.data"
              item-text="idstr"
              item-value="id"
              v-model="machine"
              label="Caută aparat"
              :return-object="true"
              apiEndpoint="machines"
            />
        </v-flex>
    </v-layout>
    <data-table
        v-if="machine && hasItems"
        @action="onRowAction"
        :actions="actions"
        :items="items"
        :headers="headers"
        entityName="Istoric"
        apiEndpoint="visitActions"
        :staticData="true"
        @staticItems="staticItems"
        :filter="filter"
        @loading="onLoading"
        mode="select"/>
    <v-flex v-if="!hasItems">
        <p class="headline text-xs-center">Nu a fost găsită nici o acțiune {{machine ? `pentru aparatul ${machine.idstr}` : ''}}</p>
    </v-flex>
    <toast-message></toast-message>
    <confirmation-dialog></confirmation-dialog>
  </v-container>
</template>

<script>
import moment from 'moment';
import DataTable from './DataTable';
import AutocompleteSelector from './AutocompleteSelector';

export default {
  components: {
    DataTable,
    AutocompleteSelector
  },
  data() {
    return {
      search: '',
      isLoaded: false,
      machine: null,
      loading: true,

      actions: [
        { name: 'Detalii vizită', color: '', event: 'open' }
      ],

      headers: [
        {
          text: 'Data',
          align: 'left',
          value: 'created_at',
          format: (item) => {
            return `<span class="v-chip white--text theme--dark ${this.$store.getters['visitActions/status'](item.status).color}"><span class="v-chip__content">${this.$store.getters['visitActions/status'](item.status).name}</span></span>
                    ${moment(item.created_at).format('DD/MM/YYYY HH:mm')}<br>
                    <strong>${item.path} (${item.duration} minute)</strong><br>
                    <strong>Angajat:</strong> ${item.visit.employee.name}<br>
                    <strong>Client:</strong> ${item.visit.machine.client_location.client.name}<br>
                    <strong>Locație client:</strong> ${item.visit.machine.client_location.name}`;
          }
        }
      ],
      filter: {},
      items: []
    };
  },

  computed: {
    hasItems() {
      return !(this.items.length === 0 && !this.loading && this.$route.params.machineId);
    },

    watchLoader: {
      get() {
        if (this.$route.params.machineId) {
          if (!this.loading) {
            this.$store.commit('CENTER_VIEW_VERTICAL', false);
          } else {
            this.$store.commit('CENTER_VIEW_VERTICAL', true);
          }
        }
      }
    }
  },

  created() {
    this.$store.commit('CENTER_VIEW_VERTICAL', false);
    if (this.$route.params.machineId) {
      this.loadDependencies()
        .then(() => {
          this.loadItems();
          this.isLoaded = true;
        });
    } else {
      this.loadItems();
      this.isLoaded = true;
    }
  },

  watch: {
    machine: function(val) {
      if (val) {
        this.$router.push({ name: 'MachinesReports', params: { machineId: val.id } });
      }
    }
  },

  methods: {
    staticItems(values) {
      this.items = values ? values.map(item => {
        if (item.action && item.action.id) {
          item.path = this.$store.getters['actions/action'](item.action.id).path;
        } else {
          item.path = '- nedefinit -';
        }
        return item;
      }) : [];
    },

    loadItems() {
      this.filter = {
        machine_id: this.machine ? this.machine.id : this.$route.params.machineId ? this.$route.params.machineId : null
      };
      if (this.filter.machine_id) {
        this.machine = this.$store.state.machines.data.find(f => f.id === ~~this.$route.params.machineId);
      }
    },

    loadDependencies() {
      return Promise.all([
        this.$store.dispatch('machines/LOAD_ONE', ~~this.$route.params.machineId),
        this.$store.dispatch('actions/LOAD', {filter: { rowsPerPage: -1 }})
      ]);
    },

    onRowAction(event) {
      switch (event.name) {
        case 'open':
          this.$router.push({ name: 'Visit', params: { id: event.data.visit_id } });
          break;
      }
    },

    onLoading(loading) {
      this.loading = loading;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MachinesReportsView.vue